import { Magic } from "magic-sdk"
import axios, { resetRefreshState } from "../axiosInstance"

const magic = new Magic(process.env.REACT_APP_MAGIC_API_KEY ?? "")
  
export const authenticate = async (didToken: string) => {
  try {
    const res = await axios.post("/auth/login", { didToken }, {
      withCredentials: true,
    })
    const { data } = res
    console.log(data)
    if (data.mfaRequired) {
      return { mfaRequired: true, userId: data.userId, userType: data.userType }
    }

    return data.user
  } catch (error) {
    console.error("Error authenticating user:", error)
    throw error
  }
}

export const fetchMe = async () => {
  try {
    const res = await axios.get("/auth/me")
    const { data } = res
    console.log("Fetched user:", data)
    return data
  } catch (error) {
    console.error("Error fetching user:", error)
    throw error
  }
}

export const verifyOtp = async ({userId, otp, userType}: {userId: number, otp: string, userType: string}) => {
  try {
    const res = await axios.post("/auth/verify-sms", { userId, code: otp, userType }, { withCredentials: true })
    resetRefreshState();
    return res.data.user
  } catch (error) {
    console.error("Error verifying OTP:", error)
    throw error
  }
}

export const authenticateWithMicrosoft = async (idToken: string) => {
  const res = await axios.post("/auth/microsoft", { idToken }, { withCredentials: true })
  resetRefreshState();
  return res.data.user
}

export const logout = async () => {
  try {
    await axios.post("/auth/logout", {}, { withCredentials: true })
    await magic.user.logout()
  } catch (error) {
    console.error("Error logging out:", error)
    throw error
  }
}